import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../services/api/errors.js';

/** Statuses worth asking again: a timeout and a rate limit. Any other 4xx is a refusal a retry cannot change. */
const RETRYABLE_CLIENT_STATUSES = new Set([408, 429]);
const MAX_RETRIES = 2;

/**
 * Retry only what can succeed on a second try: server errors, network failures, timeouts and rate limits. A 4xx is
 * answered at once, so a page shows "not found" / "not allowed" instead of a skeleton for the length of the backoff.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
    return RETRYABLE_CLIENT_STATUSES.has(error.status);
  }
  return true;
}

/**
 * The app's one query cache. Module-level so the session can clear it on sign-out: cached data belongs
 * to the identity that fetched it and must not survive into the next one.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: shouldRetryQuery } },
});
